define('views/modules/calendar/calendar/calendar-component/item/add-calendar-item-today',[
    'backbone',
    'mustache',
    'services/user',
    'views/parts/menu/menu-context',
    'text!templates/modules/calendar/calendar/calendar-component/item/calendar-add-item-today.html'
], function(
    Backbone,
    Mustache,
    User,
    VMenuContext,
    TCalendarAddItemToday
) {

    var VAddCalendarItemToday = Backbone.View.extend({
        template: TCalendarAddItemToday,

        regions: {
            menu: ".menu-options"
        },

        events: {
            "click .add-calendar-item-button": "toggleAddItemMenu"
        },

        initialize: function(url) {
            this.setUrl('root', url + moment().format('YYYY-MM-DD'));
            this.view = {};
        },

        render: function() {
            this.$el.empty().append(
                Mustache.render(this.template, Mustache.getContext({}))
            );
        },

        toggleAddItemMenu: function(e) {
            e.preventDefault();
            var view = this.view,
                menu = view.menu,
                root = this.url.root;

            if (!menu) {
                var collection = new Backbone.Collection([
                    { route: root + '/activity/', caption: 'Activity', icon: 'sl-icon-note' },
                    { route: root + '/custom_data/', caption: 'Custom data', icon: 'sl-icon-user' },
                    { route: root + '/animated/', caption: 'calendar:Animated session', icon: 'sl-icon-energy' },
                    { route: root + '/nutrilog/', caption: 'calendar:Nutrition', icon: 'sl-icon-cup' }
                ]);

                if (!User.get('_canViewAnimatedSessions')) {
                    collection.remove(collection.at(2));
                }

                // defer the creation of the option menu view
                menu = view.menu = new VMenuContext({
                    context: this,
                    onClick: this.onActionClick,
                    collection: collection
                });
            }
            this.generateZones();
            this.assign(menu, this.zone.$menu);
            // Workaround to make sure that the context menu will be at the right place
            this.zone.$menu.css('top', '41px').css('right', '3px');
            menu.toggle();
        },

    });

    return VAddCalendarItemToday;
});

